import React from 'react';

import style from './index.less';

const MessageItems = ({ data = [] }) => {
  const renderList = data => {
    const arr = [];
    if (data && Array.isArray(data)) {
      data.forEach(res => {
        arr.push(<li key={res.value}>{res.text}</li>);
      });
    }
    return <ul className={style['msg-items']}>{arr}</ul>;
  };
  return <React.Fragment>{renderList(data)}</React.Fragment>;
};

export default MessageItems;
